import {dateUtils, logging} from "@/utils/utils";
import goalApis from "@/views/GoalSettings/api";
import contractApis from "@/views/ContractManagement/api"

export default function eventApis($apiInstance, $store) {
    return {
        getEventList: async(params) => {
            try {
                const response = await $apiInstance.get('/events/list', { params });
                if(response.status !== 200 && response.status !== 201) throw new Error('wrongs status');
                return response;
            } catch (error) {
                throw new Error(error);
            }
        },
        getEventStats: async(params) => {
            try {
                $store.commit('setIsLoading', true);
                const response = await $apiInstance.post('/events/stats/db', params);
                if(response.status !== 200 && response.status !== 201) throw new Error('wrongs status');
                $store.commit('setIsLoading', false);
                return response;
            } catch (error) {
                $store.commit('setIsLoading', false);
                throw new Error(error);
            }
        },
        downloadExcel: async (params) => {
            try {
                const response = await $apiInstance.post('/events/stats/excel', params,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        responseType: 'blob',
                    }
                );
                if(response.status !== 200 && response.status !== 201) throw new Error('wrongs status');
                return response;
            } catch (error) {
                throw new Error(error);
            }
        },
        downloadParticipantsExcel: async (params) => {
            try {
                const response = await $apiInstance.post('/events/participants/excel', params,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        responseType: 'blob',
                    }
                );
                if(response.status !== 200 && response.status !== 201) throw new Error('wrongs status');
                return response;
            } catch (error) {
                throw new Error(error);
            }
        },
        getEventHospitals: async (params, success, fail) => {
            $store.commit('setIsLoading', true);

            return $apiInstance.post('/companies/list/v2', params)
                .then((response) => {
                    logging().exceptProd('event hospitals==>', response.data)
                    success(response.data);
                }, (error) => {
                    fail(error);
                }).finally(() => $store.commit('setIsLoading', false));
        },
        getSegmentDistribution: async (eventId) => {
            try {
                $store.commit('setIsLoading', true);
                const response = await $apiInstance.get(`/events-v2/segments/distribution/${eventId}`);
                if(response.status !== 200 && response.status !== 201) throw new Error('wrong status');
                $store.commit('setIsLoading', false);
                return response;
            } catch (error) {
                $store.commit('setIsLoading', false);
                throw error;
            }
        },
    }
}